<div class="loading-overlay-container">
	<span class="loading loading-bars loading-lg"></span>
</div>
